import Card from "components/card";

const SummaryItem = ({ title, icon, display }) => {
  return (
    <Card className="p-1">
      <div className="flex items-center gap-2 p-0 bg-transparent">
        <div className="p-2 rounded-xl bg-white/20 backdrop-blur-sm flex-shrink-0 ">
          <div className="text-white w-4 h-4 flex items-center justify-center">
            {icon}
          </div>
        </div>
        <div className="flex flex-col">
          <p className="display text-[12px]">{title}</p>
          <p className="text-[16px] font-semibold text-white">
            {display}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default SummaryItem;
